import { render, staticRenderFns } from "./Hcantiguas.vue?vue&type=template&id=274f08b7&scoped=true"
import script from "./Hcantiguas.vue?vue&type=script&lang=js"
export * from "./Hcantiguas.vue?vue&type=script&lang=js"
import style0 from "./Hcantiguas.vue?vue&type=style&index=0&id=274f08b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274f08b7",
  null
  
)

export default component.exports